module.exports = __webpack_public_path__ + "img/second_1.84774986.png";